import React from 'react';

/**
 * ErrorBoundary - catches render-time errors anywhere in the tree and shows
 * the actual error message instead of a blank white page. The error message
 * survives minification (only the component stack is mangled in prod builds),
 * so this is safe to surface for diagnosing staging/production crashes.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Render error caught by ErrorBoundary:', error, info);
    this.setState({ info });
  }

  handleReload = () => {
    this.setState({ error: null, info: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: '24px',
          margin: '24px auto',
          maxWidth: '900px',
          background: '#1e1e1e',
          color: '#ff6b6b',
          borderRadius: '8px',
          fontFamily: 'monospace',
          fontSize: '13px',
          lineHeight: 1.5,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}>
          <h2 style={{ color: '#fff', marginTop: 0 }}>Something went wrong</h2>
          <div style={{ color: '#ffd966', marginBottom: '12px' }}>
            {String(this.state.error?.message || this.state.error)}
          </div>
          {this.state.error?.stack && (
            <div style={{ color: '#aaa', fontSize: '12px' }}>{this.state.error.stack}</div>
          )}
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              marginTop: '16px',
              padding: '8px 16px',
              background: '#00d4ff',
              color: '#000',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
